<template>
  <div>
    <el-button
      round
      size="mini"
      class="button"
    >
      <a
        :href="item.url"
        download=""
      >下载 V{{ item.version }}</a>
    </el-button>
  </div>
</template>
<script>
export default {
  name: 'DialogFooter',
  props: {
    item: {}
  }
}
</script>

<style lang="scss" scoped>
.button {
  display: block;
  margin: 0 auto;
  height: 60px;
  width: 220px;
  background: #265CFD;
  border-radius: 30px;

  a {
    height: 28px;
    width: 40px;
    font-size: 20px;
    color: #FFFFFF;
    text-decoration: none
  }
}
</style>
